export const GENDERS_FOR_STYLE = [
  'Men',
  'Women',
  'Boys',
  'Girls',
  'Baby Boys',
  'Baby Girls'
]